"use strict";

var $ = require("jquery");

$(document).ready(function () {

    $('.widget-title').on('click', function () {
        $(this).closest('.widget').toggleClass('widget-collapse');
    });
});